/**
 * Created by sjt8736 on 2017/3/9.
 */
const crypto = require('crypto');
const iv = Buffer.alloc(16, 0);
const blockSize = 32;
let AesCrypto = function (secret) {
    this.secret = Buffer.alloc(blockSize, 0);
    Buffer.from(secret).slice(0, blockSize).copy(this.secret, 0, 0);
};

AesCrypto.prototype.encrypt = function (content) {
    //console.info(this.secret,this.secret.length);
    let cipher = crypto.createCipheriv('aes-256-cbc', this.secret, iv);
    let ciph = cipher.update(content, 'utf8', 'hex');
    ciph += cipher.final('hex');

    return ciph;
};
AesCrypto.prototype.decrypt = function (content) {
    if (!content) return content;
    let decipher = crypto.createDecipheriv('aes-256-cbc', this.secret, iv);
    let ciph = decipher.update(content, 'hex', 'utf8');
    ciph += decipher.final('utf8');
    return ciph;
};
module.exports = AesCrypto;

/*var key = 'keykeykey';
var aes = new AesCrypto(key);
var str = aes.encrypt('Hello world');
console.info(str);
console.info(aes.decrypt(str));*/
//cd01856b1bfec03bf7ca5147fc3741b6
//密文   ：
//CVVxegKXsd8eTbvUSvN9Yg==
//0955717a0297b1df1e4dbbd44af37d62

